import Layout from '../Layout'

function formatMonth(yyyyMM) {
  if (!yyyyMM) return '—'
  const [year, month] = yyyyMM.split('-')
  const date = new Date(Number(year), Number(month) - 1, 1)
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short' })
}

function formatCost(usd) {
  if (usd == null) return '$0.000000'
  return '$' + Number(usd).toFixed(6)
}

function formatTokens(n) {
  if (n == null) return '0'
  return Number(n).toLocaleString('en-US')
}

export default function Index({ rows = [] }) {
  const totalIn   = rows.reduce((acc, r) => acc + (r.total_tokens_in  || 0), 0)
  const totalOut  = rows.reduce((acc, r) => acc + (r.total_tokens_out || 0), 0)
  const totalCost = rows.reduce((acc, r) => acc + (r.total_cost_usd   || 0), 0)

  return (
    <Layout active="llm_usages">
      <div className="max-w-3xl space-y-6">
        <div>
          <h1 className="text-lg font-mono font-bold text-zinc-100">LLM Usage</h1>
          <p className="text-sm text-zinc-500 mt-1">
            Token consumption and cost by month, caller, and mode.
          </p>
        </div>

        {rows.length === 0 ? (
          <p className="text-sm font-mono text-zinc-600 py-4">
            No LLM usage recorded yet.
          </p>
        ) : (
          <section className="border border-zinc-700 rounded-lg overflow-hidden">
            <table className="w-full text-sm font-mono">
              <thead>
                <tr className="bg-zinc-800/60 text-zinc-400 text-left">
                  <th className="px-4 py-2 font-medium">Month</th>
                  <th className="px-4 py-2 font-medium">Caller</th>
                  <th className="px-4 py-2 font-medium">Mode</th>
                  <th className="px-4 py-2 font-medium text-right">Tokens In</th>
                  <th className="px-4 py-2 font-medium text-right">Tokens Out</th>
                  <th className="px-4 py-2 font-medium text-right">Cost (USD)</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-700">
                {rows.map((row, i) => (
                  <tr key={i} className="hover:bg-zinc-800/30 transition-colors">
                    <td className="px-4 py-2 text-zinc-300">{formatMonth(row.month)}</td>
                    <td className="px-4 py-2 text-zinc-300">{row.caller}</td>
                    <td className="px-4 py-2">
                      <span className={[
                        'inline-block px-1.5 py-0.5 rounded text-xs font-semibold',
                        row.mode === 'heuristic'
                          ? 'bg-zinc-800 text-zinc-400 border border-zinc-700'
                          : row.mode === 'gemini'
                            ? 'bg-blue-900/40 text-blue-400 border border-blue-800'
                            : 'bg-emerald-900/40 text-emerald-400 border border-emerald-800',
                      ].join(' ')}>
                        {row.mode}
                      </span>
                    </td>
                    <td className="px-4 py-2 text-right text-zinc-400">{formatTokens(row.total_tokens_in)}</td>
                    <td className="px-4 py-2 text-right text-zinc-400">{formatTokens(row.total_tokens_out)}</td>
                    <td className="px-4 py-2 text-right text-zinc-300">{formatCost(row.total_cost_usd)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="border-t border-zinc-700 bg-zinc-800/40 font-semibold text-zinc-200">
                  <td className="px-4 py-2" colSpan={3}>Total</td>
                  <td className="px-4 py-2 text-right">{formatTokens(totalIn)}</td>
                  <td className="px-4 py-2 text-right">{formatTokens(totalOut)}</td>
                  <td className="px-4 py-2 text-right">{formatCost(totalCost)}</td>
                </tr>
              </tfoot>
            </table>
          </section>
        )}
      </div>
    </Layout>
  )
}
